import styles from "./WoodenDesignPlateReusable.module.css";

import { ReactSortable } from "react-sortablejs";
import GridItemSidesImage from "./GridItemSidesImage";
// import html2canvas from "html2canvas";
import html2canvas from "html2canvas-support-css";
import play_icon from "../../../assets/images/icons/play_icon.png";

import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import gallery_icon from "../../../assets/images/icons/gallery_ace.svg";
import GridItemMiddleTextDiv from "./GridItemMiddleTextDiv";

import domtoimage from "dom-to-image";
import FontFaceObserver from "fontfaceobserver";

import { useNavigate } from "react-router-dom";
import EditScreenSelector from "../../Reusables/EditScreenSelector";
import { Link, scroller } from "react-scroll";
const WoodenDesignPlateReusable = React.forwardRef(
  (
    {
      index,
      callback,
      callbackPreviewChange,
      state,
      image_selection_popup,
      //new stuff
      saveThisProduct,
      changeCopyDetails,
      selectedCopyDetails,
      currentPageNumber,
      totalPageNumber,
      confirmEdits,
      generatePreviewsAtBottom,
      preview_copied_image,
    },
    ref
  ) => {
    const navigate = useNavigate();
    //refs
    const divRef = useRef(null);
    const previewRef = useRef(null);
    //functional state
    let pci = "";

    if (selectedCopyDetails !== currentPageNumber) {
      pci = preview_copied_image;
    }
    const [check, setCheck] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [previewImage, setPreviewImage] = useState(pci);

    //parent states
    const {
      choice,
      name,
      ageInMonths,
      plan,
      date,
      DOBWestern,
      birthTime,
      birthHeight,
      birthWeight,
      imageLeftCount,
      images,
    } = state;

    const changeState = (key, value) => {
      state[key] = value;
      callback(state);
    };
    const changeStateMultiple = (keys, values) => {
      for (let i = 0; i < keys.length; i++) {
        state[keys[i]] = values[i];
      }
      callback(state);
    };
    const convertDataUrlToFile = (dataUrl, filename, mimeType) => {
      const arr = dataUrl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mimeType });
    };
    const changePreview = async () => {
      if (selectedCopyDetails !== currentPageNumber) {
        return convertDataUrlToFile(previewImage, "image.png", "image/png");
      } else {
        if (showPreview) {
          return convertDataUrlToFile(previewImage, "image.png", "image/png");
        }
        html2canvas(divRef.current, {
          logging: true,
          letterRendering: 1,
          allowTaint: false,
          useCORS: true,
        }).then((canvas) => {
          // create an image from the canvas
          return canvas.toDataURL();
        });
      }
      return false;
    };

    useImperativeHandle(ref, () => ({
      changePreview,
    }));

    const uploadImage = (num, id) => {
      if (num === 1) {
        image_selection_popup(index, 1, id);
      } else {
        let imagesLeft = 0;
        for (let i = 0; i < 9; i++) {
          if (images[i].id === -1) {
            continue;
          }
          if (images[i].src === "") imagesLeft++;
        }
        if (imagesLeft !== 0) {
          image_selection_popup(index, imagesLeft, -1);
        } else return;
      }
    };
    const reshuffle = (pics) => {
      if (pics[4].id === -1) return pics;
      let items = [...pics];
      let blankIndex = items.findIndex((pics) => pics.id === -1);

      if (blankIndex < 4) {
        for (let i = blankIndex; i < 4; i++) {
          let temp = items[i];
          items[i] = items[i + 1];
          items[i + 1] = temp;
        }
      } else {
        for (let i = blankIndex; i > 4; i--) {
          let temp = items[i];
          items[i] = items[i - 1];
          items[i - 1] = temp;
        }
      }
      return items;
    };
    const onDragDropEnds = (oldIndex, newIndex) => {
      console.log(oldIndex, newIndex);
      if (oldIndex === 9) {
        oldIndex = 8;
      }
      if (newIndex === 9) {
        newIndex = 8;
      }
      let draggedItem = null;
      let itemOnWhichDraggedItemDropped = null;
      if (oldIndex !== 4 || newIndex !== 4) {
        draggedItem = images[oldIndex];
        itemOnWhichDraggedItemDropped = images[newIndex];
      }
      let newImages = [...images];
      newImages[oldIndex] = itemOnWhichDraggedItemDropped;
      newImages[newIndex] = draggedItem;
      console.log(newImages.length);
      changeState("images", newImages);
    };
    const selectedCallback = (id) => {
      let items = [...images];
      const idx = items.findIndex((photo) => photo.id === id);

      if (items[idx].photoSelected) {
        items[idx].photoSelected = false;
      } else {
        for (let i of items) {
          i.photoSelected = false;
        }
        items[idx].photoSelected = true;
      }
      changeState("images", items);
    };

    const setZoomLevel = (id, zoomLevel) => {
      const index = images.findIndex((photo) => photo.id === id);
      let items = [...images];
      items[index].zoomLevel = zoomLevel;
      changeState("images", items);
    };
    const imageCloseCallback = (id) => {
      const index = images.findIndex((photo) => photo.id === id);
      let items = [...images];
      items[index].src = "";
      items[index].zoomLevel = 1;
      items[index].photoSelected = false;
      changeStateMultiple(
        ["images", "imagesLeftCount"],
        [items, imageLeftCount + 1]
      );
    };

    const copyGridToPreview = () => {
      // Get the canvas and context
      html2canvas(divRef.current, {
        logging: true,
        letterRendering: 1,
        allowTaint: false,
        useCORS: true,
      }).then((canvas) => {
        // create an image from the canvas
        setPreviewImage(canvas.toDataURL());
      });
    };
    const pointPhotoButtonClicked = () => {
      navigate("/point-photo-1");
    };

    //new 1
    const copyOptions = [];
    for (let i = 1; i < currentPageNumber; i++) {
      copyOptions.push(i + "個目と同じ");
    }
    copyOptions.push("別のデザインで作る");

    let copySelected = selectedCopyDetails + "個目の写真";
    const extractNumber = (s, currentPageNumber, totalPageNumber) => {
      for (let i = totalPageNumber; i > 0; i--) {
        if (s.includes(i)) {
          return i;
        }
      }
      return currentPageNumber;
    };
    return (
      <div className={styles.main_div}>
        <div className={styles.header_section_main}>
          {currentPageNumber === 1 && (
            <div name="編　集" className={styles.header_section_head01}>
              編　　集
            </div>
          )}
          {totalPageNumber > 1 && (
            <div
              className={styles.header_number}
              name={"editsection" + currentPageNumber}
            >
              {currentPageNumber + "個目"}
            </div>
          )}
        </div>
        {currentPageNumber > 1 && (
          <div className={styles.multi_page_selector_wrapper}>
            <div className={styles.multi_page_selector}>
              <EditScreenSelector
                takeupspace={true}
                options={copyOptions}
                callback={(value) => {
                  changeCopyDetails(
                    extractNumber(value, currentPageNumber, totalPageNumber),
                    index
                  );
                  // changeState("sec03textbox", value);
                  // setSec03textbox(value);
                }}
                selected={copySelected}
              />
            </div>
          </div>
        )}
        {selectedCopyDetails === currentPageNumber && (
          <>
            <div className={styles.choice_section}>
              <div className={styles.radio_section}>
                <div className={styles.radio_section_text}>
                  文字入れ部分のパターンを選択し、情報をご記入ください
                </div>
                <div className={styles.radio_section_main}>
                  <div className={styles.radio_section02}>
                    <div className={styles.element0}>
                      <div className={styles.radio_button}>
                        <input
                          className={styles.radio}
                          type="radio"
                          name={"language"}
                          //   onChange={() => {}}
                          onClick={(event) => {
                            changeState("choice", "A");
                          }}
                          defaultChecked
                          check={choice === "A"}
                        />
                      </div>
                      <div className={styles.radio_text}>
                        パターンA（お名前・月齢・出生情報）
                      </div>
                    </div>
                    <div
                      className={styles.element + " " + styles.radio_button_2}
                    >
                      <div className={styles.radio_button}>
                        <input
                          className={styles.radio}
                          type="radio"
                          onClick={(event) => {
                            changeState("choice", "B");
                          }}
                          name={"language"}
                          check={choice === "B"}
                        />
                      </div>
                      <div className={styles.radio_text}>
                        パターンB（お名前・プラン・日付）
                      </div>
                    </div>
                    <div
                      className={styles.element + " " + styles.radio_button_2}
                    >
                      <div className={styles.radio_button}>
                        <input
                          className={styles.radio}
                          type="radio"
                          onClick={(event) => {
                            changeState("choice", "C");
                          }}
                          check={choice === "C"}
                          name={"language"}
                        />
                      </div>
                      <div className={styles.radio_text}>
                        パターンC（お名前・日付）
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.position_div}>
                <div
                  style={{ width: 197 + "px", height: 196 + "px" }}
                  className={styles.position_grid}
                >
                  <div className={`${styles.position_grid_item} `}>1</div>
                  <div className={`${styles.position_grid_item} `}>2</div>
                  <div
                    className={`${styles.position_grid_item}  ${styles.right_border}`}
                  >
                    3
                  </div>
                  <div className={`${styles.position_grid_item} `}>4</div>
                  <div
                    className={`${styles.position_grid_item} ${styles.grid_item_middle_text}`}
                  >
                    文字入れエリア
                  </div>
                  <div
                    className={`${styles.position_grid_item} ${styles.right_border}`}
                  >
                    5
                  </div>
                  <div
                    className={`${styles.position_grid_item}  ${styles.bottom_border} `}
                  >
                    6
                  </div>
                  <div
                    className={`${styles.position_grid_item} ${styles.bottom_border} `}
                  >
                    7
                  </div>
                  <div
                    className={`${styles.position_grid_item}  ${styles.bottom_border}  ${styles.right_border}`}
                  >
                    8
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.hr_choice_selection_bottom}></div>
            <div className={styles.form_section}>
              {choice === "A" && (
                <div className={styles.formA_main}>
                  <div className={styles.singleA_div}>
                    <div className={styles.singleA_div_label}>
                      名前（アルファベット）
                    </div>
                    <div className={styles.singleA_div_input_text}>
                      <input
                        className={styles.choice_form_input_text}
                        type="text"
                        placeholder="Misaki"
                        onChange={(e) => {
                          changeState("name", e.target.value);
                        }}
                        value={name}
                      />
                    </div>
                  </div>
                  <div className={styles.singleA_div_helper}>
                    <div className={styles.singleA_div_label_helper}></div>
                    <div className={styles.singleA_div_input_text_helper}>
                      ※筆記体のため頭文字以外は小文字です。
                    </div>
                  </div>
                  <div
                    className={`${styles.singleA_div} ${styles.divA_single_top_spacing}`}
                  >
                    <div className={styles.singleA_div_label}>
                      出生日からの日齢・月齢
                    </div>
                    <div className={styles.singleA_div_input_text}>
                      <input
                        className={styles.choice_form_input_text}
                        type="text"
                        placeholder="10days,100days,2monthsなど"
                        onChange={(e) => {
                          changeState("ageInMonths", e.target.value);
                        }}
                        value={ageInMonths}
                      />
                    </div>
                  </div>
                  <div
                    className={`${styles.singleA_div} ${styles.divA_single_top_spacing}`}
                  >
                    <div className={styles.singleA_div_label}>
                      生年月日（西暦）
                    </div>
                    <div className={styles.singleA_div_input_text}>
                      <input
                        className={styles.choice_form_input_text}
                        type="text"
                        placeholder="2022.05.23"
                        onChange={(e) => {
                          changeState("DOBWestern", e.target.value);
                        }}
                        value={DOBWestern}
                      />
                    </div>
                  </div>
                  <div
                    className={`${styles.singleA_div} ${styles.divA_single_top_spacing}`}
                  >
                    <div className={styles.singleA_div_label}>出生時間</div>
                    <div className={styles.singleA_div_input_text}>
                      <input
                        className={styles.choice_form_input_text}
                        type="text"
                        placeholder="17:35"
                        onChange={(e) => {
                          changeState("birthTime", e.target.value);
                        }}
                        value={birthTime}
                      />
                    </div>
                  </div>
                  <div
                    className={`${styles.singleA_div} ${styles.divA_single_top_spacing}`}
                  >
                    <div className={styles.singleA_div_label}>出生児の体重</div>
                    <div className={styles.singleA_div_input_text}>
                      <input
                        className={styles.choice_form_input_text}
                        type="text"
                        placeholder="3300g"
                        onChange={(e) => {
                          changeState("birthWeight", e.target.value);
                        }}
                        value={birthWeight}
                      />
                    </div>
                  </div>
                  <div
                    className={`${styles.singleA_div} ${styles.divA_single_top_spacing}`}
                  >
                    <div className={styles.singleA_div_label}>出生時の身長</div>
                    <div className={styles.singleA_div_input_text}>
                      <input
                        className={styles.choice_form_input_text}
                        type="text"
                        placeholder="50.2cm"
                        onChange={(e) => {
                          changeState("birthHeight", e.target.value);
                        }}
                        value={birthHeight}
                      />
                    </div>
                  </div>
                </div>
              )}
              {choice === "B" && (
                <div className={styles.formB_main}>
                  <div className={styles.singleB_div}>
                    <div className={styles.singleB_div_label}>
                      名前（アルファベット）
                    </div>
                    <div className={styles.singleB_div_input_text}>
                      <input
                        className={styles.choice_form_input_text}
                        type="text"
                        placeholder="Misaki"
                        onChange={(e) => {
                          changeState("name", e.target.value);
                        }}
                        value={name}
                      />
                    </div>
                  </div>
                  <div className={styles.singleB_div_helper}>
                    <div className={styles.singleB_div_label_helper}></div>
                    <div className={styles.singleB_div_input_text_helper}>
                      ※筆記体のため頭文字以外は小文字です。
                    </div>
                  </div>
                  <div
                    className={`${styles.singleB_div} ${styles.divB_single_top_spacing}`}
                  >
                    <div className={styles.singleB_div_label}>プランなど</div>
                    <div className={styles.singleB_div_input_text}>
                      <input
                        className={styles.choice_form_input_text}
                        type="text"
                        placeholder="1st Birthday, 753など"
                        onChange={(e) => {
                          changeState("plan", e.target.value);
                        }}
                        value={plan}
                      />
                    </div>
                  </div>
                  <div
                    className={`${styles.singleB_div} ${styles.divB_single_top_spacing}`}
                  >
                    <div className={styles.singleB_div_label}>日付</div>
                    <div className={styles.singleB_div_input_text}>
                      <input
                        className={styles.choice_form_input_text}
                        type="text"
                        placeholder="2022.05.23"
                        onChange={(e) => {
                          changeState("date", e.target.value);
                        }}
                        value={date}
                      />
                    </div>
                  </div>
                </div>
              )}

              {choice === "C" && (
                <div className={styles.formB_main}>
                  <div className={styles.singleB_div}>
                    <div className={styles.singleB_div_label}>
                      名前（アルファベット）
                    </div>
                    <div className={styles.singleB_div_input_text}>
                      <input
                        className={styles.choice_form_input_text}
                        type="text"
                        placeholder="Misaki"
                        onChange={(e) => {
                          changeState("name", e.target.value);
                        }}
                        value={name}
                      />
                    </div>
                  </div>
                  <div className={styles.singleB_div_helper}>
                    <div className={styles.singleB_div_label_helper}></div>
                    <div className={styles.singleB_div_input_text_helper}>
                      ※筆記体のため頭文字以外は小文字です。
                    </div>
                  </div>

                  <div
                    className={`${styles.singleB_div} ${styles.divB_single_top_spacing}`}
                  >
                    <div className={styles.singleB_div_label}>日付</div>
                    <div className={styles.singleB_div_input_text}>
                      <input
                        className={styles.choice_form_input_text}
                        type="text"
                        placeholder="2022.05.23"
                        onChange={(e) => {
                          changeState("date", e.target.value);
                        }}
                        value={date}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className={styles.hr_choice_form_bottom}></div>
            <div className={styles.upload_section}>
              <div className={styles.upload_section_text}>
                写真を{imageLeftCount}枚選択後、写真の配置をしてください。
              </div>
              <div
                onClick={(event) => {
                  uploadImage(0);
                }}
                className={styles.upload_image_placeholder}
              >
                <img
                  className={styles.upload_image_gallery_icon}
                  src={gallery_icon}
                  alt="top_gallery"
                />

                <div className={styles.upload_image_placeholder_text}>
                  写真選択
                </div>
              </div>
            </div>
            <div className={styles.hr_upload_image_bottom}></div>
            <div
              className={styles.photo_grid_main}
              // style={{ marginTop: choice === "A" ? 150 : choice === "C" ? 140 : "0" }}
              ref={divRef}
            >
              <ReactSortable
                list={images}
                setList={(newList) => {
                  // changeState("images", newList);
                }}
                ghostClass="dropArea"
                handle=".dragHandle"
                filter=".ignoreDrag"
                ignore=".ignore"
                preventOnFilter={true}
                className={styles.grid_container}
                onEnd={({ oldIndex, newIndex }) =>
                  onDragDropEnds(oldIndex, newIndex)
                }
                width={900}
                height={900}
              >
                {Array.isArray(images) &&
                  images.length > 0 &&
                  images.map((photo, index) => {
                    const newItems = reshuffle(images);
                    return (
                      <GridItemSidesImage
                        key={index}
                        id={index}
                        photo={newItems[index]}
                        removeCallback={imageCloseCallback}
                        uploadCallback={uploadImage}
                        selectedCallback={selectedCallback}
                        zoomLevelCallback={setZoomLevel}
                      />
                    );
                  })}
                <GridItemMiddleTextDiv
                  type={choice === "B" ? "B" : choice === "A" ? "A" : "C"}
                  data={
                    choice === "B"
                      ? [name, plan, date]
                      : choice === "A"
                      ? [
                          name,
                          ageInMonths,
                          DOBWestern,
                          birthTime,
                          birthWeight,
                          birthHeight,
                        ]
                      : [name, date]
                  }
                />
              </ReactSortable>
            </div>

            <div className={styles.grid_info_section01}>
              <div className={styles.grid_info_section01_text01}>
                <div>
                  写真の位置調整・配置変更：カーソルを合わせてドラッグしてください。
                </div>
                <div className={styles.grid_info_section01_text01_01}>
                  拡大縮小：クリックして青枠が出た状態で＋ーを押してください。
                </div>
              </div>
              <div
                onClick={pointPhotoButtonClicked}
                className={styles.grid_info_section01_text02}
              >
                <img
                  className={styles.link_play_icon}
                  src={play_icon}
                  alt="pico"
                />
                写真配置のポイント
              </div>
            </div>
            <div className={styles.photo_checkbox_main_div}>
              <div className={styles.photo_checkbox_text01}>
                写真の配置にどうしても迷ったら、「デザイナーおまかせ」にチェックを入れてください。
              </div>
              <div className={styles.photo_checkbox_text02}>
                <div className={styles.photo_checkbox_text02_checkbox}>
                  <input
                    type="checkbox"
                    className={styles.photo_checkbox_input}
                    checked={check}
                    onChange={() => {
                      setCheck(!check);
                    }}
                  />
                </div>
                <div className={styles.photo_checkbox_text02_right}>
                  写真の配置をデザイナーおまかせにする
                </div>
              </div>

              <div className={styles.photo_checkbox_text03}>
                <div className={styles.photo_checkbox_text03_top}>
                  ※プレビューでは現時点の配置内容が表示されます。
                </div>
                <div className={styles.photo_checkbox_text03_bot}>
                  おまかせ希望の方は、ご入稿後にお送りする「完成デザイン画像」にて配置を確認してください。
                </div>
              </div>
            </div>
          </>
        )}
        <div className={styles.show_preview_button_div}>
          <div className={styles.show_preview_button_top_text}>
            すべてを選択後、プレビューボタンをクリックしてください。
          </div>

          <button
            onClick={() => {
              setShowPreview(true);
              if (currentPageNumber === selectedCopyDetails) {
                copyGridToPreview();
              }
            }}
            className={styles.show_preview_button}
          >
            プレビュー
          </button>
        </div>
        {showPreview && (
          <div className={styles.preview_section_main_div}>
            <div className={styles.preview_section_main_top_hr}></div>
            <div className={styles.preview_header_main_div}>
              <div className={styles.preview_header_main}>
                デザインプレビュー
              </div>
              <div className={styles.preview_header_text}>
                ※「デザイナーおまかせ配置」を選択された方は、文字の内容に誤りがないかチェックをしてください。
              </div>
            </div>
            <div ref={previewRef} className={styles.preview_photo_section}>
              <img
                src={
                  currentPageNumber === selectedCopyDetails
                    ? previewImage
                    : preview_copied_image
                    ? URL.createObjectURL(preview_copied_image)
                    : ""
                }
                alt="pv img"
                height={900}
                width={900}
              />
            </div>
          </div>
        )}
        <div className={styles.confirm_edits_wrapper}>
          <div className={styles.confirm_edits}>
            <div className={styles.confirm_header}>
              上記の内容でデザイン決定しますか？
            </div>
            <div className={styles.confirm_button_section}>
              <Link
                to={
                  totalPageNumber === 1
                    ? "編　集"
                    : "editsection" + currentPageNumber
                }
                spy={true}
                smooth={true}
                offset={-250}
                duration={500}
              >
                <button className={styles.confirm_button_no}>編集へ戻る</button>
              </Link>
              <button
                onClick={() => {
                  if (totalPageNumber === 1) {
                    confirmEdits();
                  } else {
                    if (currentPageNumber < totalPageNumber) {
                      const elementName =
                        "editsection" + (currentPageNumber + 1);

                      scroller.scrollTo(elementName, {
                        spy: true,
                        smooth: true,
                        offset: -100,
                        duration: 500,
                      });
                    } else {
                      generatePreviewsAtBottom();
                    }
                  }
                }}
                className={styles.confirm_button_yes}
              >
                はい
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default WoodenDesignPlateReusable;
